import BlankMyPrepaidCard from '@components/blank/BlankMyPrepaidCard';
import Column from '@components/Column';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import useUserPrepaidCards from '../../hooks/useUserPrepaidCards';
import PrepaidCardItem from '../PrepaidCardItem';

function PrepaidCardList() {
    const { prepaidCards, isLoading, isBlank } = useUserPrepaidCards();
    return (
        <Container as='section'
            fullWidth
            align='center'
            spacing={18}>
            {isLoading && (
                <Loading size='small' />
            )}
            {isBlank && (
                <BlankMyPrepaidCard/>
            )}
            {prepaidCards?.map((prepaidCard) => (
                <PrepaidCardItem prepaidCard={prepaidCard}
                    key={prepaidCard.id} />
            ))}
        </Container>
    );
}

const Container = styled(Column)`
    min-height: 100vh;
    padding: 0 20px 44px;
`;

export default PrepaidCardList;
